// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Belt__Belt_Result from "melange.belt/belt_Result.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as $$Promise from "../../../vendored/promise/promise.js";

const and$star = $$Promise.all2;

const Async = {
  let$plus: $$Promise.map,
  let$star: $$Promise.flatMap,
  and$star: and$star
};

function and$star$1(o1, o2) {
  if (o1 !== undefined && o2 !== undefined) {
    return [
            Caml_option.valFromOption(o1),
            Caml_option.valFromOption(o2)
          ];
  }
  
}

const $$Option = {
  let$plus: Belt__Belt_Option.map,
  let$star: Belt__Belt_Option.flatMap,
  and$star: and$star$1
};

function and$star$2(r1, r2) {
  if (r1.TAG === /* Ok */0) {
    if (r2.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: [
                r1._0,
                r2._0
              ]
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: r2._0
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: r1._0
          };
  }
}

const Result = {
  let$plus: Belt__Belt_Result.map,
  let$star: Belt__Belt_Result.flatMap,
  and$star: and$star$2
};

function and$star$star$bang(lr1, lr2) {
  return $$Promise.map($$Promise.all2(lr1, lr2), (function (param) {
                const x = param[0];
                if (x.TAG !== /* Ok */0) {
                  return {
                          TAG: /* Error */1,
                          _0: x._0
                        };
                }
                const y = param[1];
                if (y.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: [
                            x._0,
                            y._0
                          ]
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: y._0
                        };
                }
              }));
}

const Bindings = {
  let$plus: $$Promise.map,
  let$star: $$Promise.flatMap,
  and$star: and$star,
  let$star$question: Belt__Belt_Option.flatMap,
  let$plus$question: Belt__Belt_Option.map,
  and$star$question: and$star$1,
  let$star$bang: Belt__Belt_Result.flatMap,
  let$plus$bang: Belt__Belt_Result.map,
  and$star$bang: and$star$2,
  let$star$star$bang: $$Promise.flatMapOk,
  let$plus$plus$bang: $$Promise.mapOk,
  and$star$star$bang: and$star$star$bang
};

export {
  Async ,
  $$Option ,
  Result ,
  Bindings ,
}
/* Promise Not a pure module */
